import React from 'react';

import {
  Flex,
  Divider,
  PageWrapper,
  OneHalfLayout
} from '@ubisend/pulse-components';
import {
  useAuth,
  FEATURE_GATES,
  FeatureFilter,
  GlobalRoleFilter,
  GlobalFeatureGateFilter
} from '@ubisend/pulse-auth';
import { BackButton } from '@ubisend/pulse-channels';

import { BotSettingsProvider } from '../Providers';
import {
  FontCode,
  EmbedPreview,
  SaveSettings,
  AvatarSettings,
  DeploymentCode,
  ComposerSettings,
  EmbedColourSettings,
  EmbedFooterSettings,
  SettingPageSettings,
  EmbedGeneralSettings
} from '../Components';
import {
  getEmbedSettings,
  updateEmbedSettings,
  updateEmbedLogo
} from '../api';

const EmbedSettings = () => {
  const { client } = useAuth();

  const deployment = {
    script: `<iframe src="${process.env.REACT_APP_EMBED_PAGE_DEPLOYMENT_ROOT_URL}?c=${process.env.REACT_APP_INSTALL_NAME}&i=${client.identifier}" id="chat-widget-1925" style="border: none; width: 100%; height: 100%;"></iframe>`,
    info: 'Paste this snippet anywhere on your web page.'
  };

  return (
    <PageWrapper
      header={'Embedded Widget'}
      prevAction={<BackButton to="/channels" />}
      subheader={`Manage the appearance of your Embedded Widget`}>
      <Flex>
        <BotSettingsProvider
          type="embed"
          getBotSettings={getEmbedSettings}
          updateBotLogo={updateEmbedLogo}
          updateBotSettings={updateEmbedSettings}
          deploymentDetails={deployment}>
          <OneHalfLayout>
            <Flex mr col ySpace>
              <DeploymentCode />
              <Divider pb />
              <EmbedGeneralSettings />
              <Divider pb />
              <EmbedColourSettings />
              <GlobalFeatureGateFilter for={FEATURE_GATES.WHITELABEL_FOOTER}>
                <FeatureFilter feature="whitelabel footer">
                  <GlobalRoleFilter for="owner">
                    <Divider pb />
                    <EmbedFooterSettings />
                  </GlobalRoleFilter>
                </FeatureFilter>
              </GlobalFeatureGateFilter>
              <Divider pb />
              <FontCode />
              <Divider pb />
              <AvatarSettings />
              <Divider pb />
              <ComposerSettings />
              <Divider pb />
              <SettingPageSettings />
              <Divider pb />
              <SaveSettings />
            </Flex>
          </OneHalfLayout>
          <OneHalfLayout>
            <EmbedPreview />
          </OneHalfLayout>
        </BotSettingsProvider>
      </Flex>
    </PageWrapper>
  );
};

export default EmbedSettings;
